import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// New read-only popup/report APIs: colocate useXxxQuery with the feature
// component and reuse authApi for requests. Existing flows stay on Redux Thunks.
